"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author siranush.avetisyan
 * @since 10/03/17.
 */
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_export_client_js_1 = require("@synisys/idm-export-client-js");
require("./de-export.component.scss");
var abstract_destruction_subject_1 = require("../../shared/utilities/abstract-destruction-subject");
/**
 *  Export item control, with exporting and downloading possibilities.
 */
var DeExportComponent = /** @class */ (function (_super) {
    __extends(DeExportComponent, _super);
    function DeExportComponent(_exportService) {
        var _this = _super.call(this) || this;
        _this._exportService = _exportService;
        _this.ExportType = idm_export_client_js_1.ExportType;
        /**
         * Enabled Export Types.
         * Default value is [ExportType.PDF, ExportType.EXCEL, ExportType.RTF].
         *
         * @type {Array<ExportType>}
         */
        _this.enabledExportTypes = [idm_export_client_js_1.ExportType.PDF, idm_export_client_js_1.ExportType.EXCEL, idm_export_client_js_1.ExportType.RTF];
        /**
         * Exported file name.
         * Default value is "export".
         *
         * @type {string}
         */
        _this.fileName = 'export';
        /**
         * Message Component Ids.
         * When we don't pass any value for this field then export service get all component messages.
         * If we don't pass any value then export service loads all component messages.
         *
         * @type {Array<number>}
         */
        _this.messageComponentIds = null;
        return _this;
    }
    DeExportComponent.prototype.export = function (exportType) {
        this._exportService.export(this.categorySystemName, this.categoryItemId, this.currentLanguageId, exportType, this.layoutName, this.fileName, this.messageComponentIds)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function () { }, function (err) { return console.error(err); });
    };
    DeExportComponent.prototype.isEnabled = function (exportType) {
        return this.enabledExportTypes.indexOf(exportType) > -1;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DeExportComponent.prototype, "categorySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DeExportComponent.prototype, "categoryItemId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DeExportComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DeExportComponent.prototype, "enabledExportTypes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DeExportComponent.prototype, "layoutName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DeExportComponent.prototype, "fileName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DeExportComponent.prototype, "messageComponentIds", void 0);
    DeExportComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'de-export',
            template: require('./de-export.component.html'),
        }),
        __metadata("design:paramtypes", [idm_export_client_js_1.ExportService])
    ], DeExportComponent);
    return DeExportComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.DeExportComponent = DeExportComponent;
//# sourceMappingURL=de-export.component.js.map